module.exports = __webpack_public_path__ + "static/media/lese-is-wrong.d510ec42.mp3";